import "./legal.css";
import type { ShowLegal } from "../features/contracts";
import { icon } from "./iconsKit";
import { sheetHeadHtml } from "./components";
import { CREDITS, PRIVACY_URL, SUPPORT_CONTACT } from "./legalText";

/**
 * Settings → About & credits (FINISH_PLAN WP4.5, X15; M39 copy pass): the makers and the licences they ship under, then
 * one link row to the privacy policy (the static privacy.html, App Store 5.1.1) and, once Kevin sets one, the support
 * address. No terms or policy prose in the game (M39: Kevin keeps the game out of any country that would need it).
 */

/** The sheet's portrait: a rolled scroll with lines of text (the kit has no document icon). */
function scrollGlyph(size: number, color: string): string {
  return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 3h11a3 3 0 0 1 0 6h-1v9a3 3 0 0 1-3 3H6a3 3 0 0 1 0-6h1V3z"/><path d="M18 9H9.5M7 15h7M10 7h5M10 11h5"/></svg>`;
}

const esc = (s: string) => s.replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]!);

const linkRow = (href: string, label: string, ext: boolean) =>
  `<a class="lrow" href="${esc(href)}"${ext ? ` target="_blank" rel="noopener"` : ""}><b>${esc(label)}</b>${icon("chev", 16)}</a>`;

function bodyHtml(): string {
  const credits = CREDITS.map((c) => `<div class="credit"><b>${esc(c.what)}</b><span>${esc(c.who)}</span><span>${c.url ? `<a href="${esc(c.url)}" target="_blank" rel="noopener">${esc(c.licence)}</a>` : esc(c.licence)}</span></div>`).join("");
  const links = linkRow(PRIVACY_URL, "Privacy policy", true) + (SUPPORT_CONTACT ? linkRow(`mailto:${SUPPORT_CONTACT}`, "Write to us", false) : "");
  return `<div class="links">${links}</div>${credits}`;
}

export const showLegal: ShowLegal = (parent) => {
  const sheet = document.createElement("div");
  sheet.className = "sheet panel legal";
  // The same portrait header as the other hub sheets (Almanac, Events, Shop…), not the Settings ribbon.
  sheet.innerHTML = `${sheetHeadHtml({ title: "About &amp; credits", portrait: scrollGlyph(36, "#5a3606"), tint: "gold" })}
    <div class="lbody">${bodyHtml()}</div>`;
  sheet.querySelector<HTMLButtonElement>(".close")!.onclick = () => sheet.remove();
  parent.append(sheet);
  return sheet;
};
